import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_result_order",
  "use": "icon-icon_result_order-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"icon-icon_result_order\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h64v64H0z\" /><path d=\"M56 21.333v34.648a2.667 2.667 0 0 1-2.648 2.686H10.648A2.648 2.648 0 0 1 8 56.02V7.98c0-1.432 1.197-2.646 2.672-2.646h29.32l16.008 16ZM50.667 24H37.333V10.667h-24v42.666h37.334V24Zm-29.334-5.333h8V24h-8v-5.333Zm0 10.666h21.334v5.334H21.333v-5.334Zm0 10.667h21.334v5.333H21.333V40Z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol